import PolyIcon from "elements/PolyIcon";
import React, { useEffect, useState } from "react";
import "./DropdownButton.scss";

export const DropdownButton: React.FC<{
  title: string;
  icon?: string;
  iconClassName?: string;
  disabled?: boolean;
  className?: string;
}> = ({ title, icon, iconClassName, disabled, className, children }) => {
  const [open, setOpen] = useState(false);
  const self = React.useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (!self?.current?.contains(e.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClick, false);

    return () => {
      document.removeEventListener("mousedown", handleClick, false);
    };
  }, []);

  const buttonClassName = [
    className,
    icon ? "btn-poly-icon" : "btn",
    disabled ? "disabled" : ""
  ].join(" ");
  const dropdownClassName = open ? "open" : "";

  return (
    <div className="dropdown-btn d-inline-block relative">
      <button
        className={`d-inline-block ${buttonClassName}`}
        disabled={disabled}
        onClick={() => {
          setOpen(!open);
        }}
        ref={self}
      >
        {icon ? (
          <PolyIcon icon={icon} title={title} className={iconClassName} />
        ) : (
          title
        )}
      </button>
      <ul
        className={`dropdown-menu p-0 mt-5 absolute ${dropdownClassName}`}
        data-testid="dropdown-menu"
      >
        {React.Children.map(
          children,
          (item, index) =>
            React.isValidElement(item) && (
              <li key={index}>
                {React.cloneElement(item, {
                  className: `dropdown-item block p-5 font-sm ${item.props
                    .className ?? ""}`
                })}
              </li>
            )
        )}
      </ul>
    </div>
  );
};
